export default "/capture-preview.2b2dcf8b-af13af.jpg";